/**
 * @module businessComponents\mdl\materialSelector
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { MethodService } from "../../../utils/serviceModel";

@Component
export default class MaterialSelector extends Vue {
  @Prop({ default: "选择物料" })
  private title!: string;

  @Prop({ default: false })
  private multiple!: boolean;

  private value: any[] = [];

  private isBusy = false;

  private items = [];

  private totals = 0;

  private get allowSubmit() {
    return this.value.length > 0;
  }

  private headers: ITableHeader[] = [
    {
      value: "Cd",
      text: "编码"
    },

    {
      value: "Name",
      text: "名称"
    },
    {
      value: "Ctrl",
      text: "型号"
    },
    {
      value: "PackingSpec",
      text: "包装规格"
    },
    {
      value: "Developer",
      text: "开发人"
    }
  ];

  private args = {
    typeCd: "",
    keyword: "",
    pagination: { rowsPerPage: 10, sortBy: "Cd" }
  };

  private rowInital(props: ITableRowProps) {}

  @Watch("args.pagination", { deep: true })
  private async query() {
    this.isBusy = true;
    try {
      let res = await this.service.invokeAsyn(this.args);
      if (res.data.isSuccess) {
        this.items = res.data.data[1];
        this.totals = res.data.data[0];
      }
    } catch (error) {
      this.items = [];
      this.totals = 0;
    } finally {
      this.isBusy = false;
    }
  }

  private submit() {
    this.$emit("submit", this.value);
    this.value = [];
  }

  private service = new MethodService(
    "dynamic_parse_page",
    "5cac6210d2a0eb1690b334e3",
    "query"
  );
}
